import IApiResponse from "../../interfaces/IApiResponse";
import SuccessApiResponse from "../../data/SuccessApiResponse";
import IFellowshipSettings from "../../interfaces/IFellowshipSettings";
import { IFellowshipSettingsService } from "../FellowshipSettingsService";
import SQLiteHelperService from "../SQLiteHelperService";
import { SQLiteTables } from "../../data/SQLiteTables";
import SQLiteDB from "../../data/SQLiteDB";
import ISQLiteResponse from "../../interfaces/ISQLiteResponse";

const dbFailedResponse = Promise.resolve({
    Data: undefined,
    Success: false,
    Message: { UserMessage: 'db not connected', ServerMessage: 'db not connected' }});

const FellowshipSettingsServiceHybrid: IFellowshipSettingsService = {
    
    createFellowshipSettings: async (fellowshipSettings) => {
        const newFellowshipSettings: any  = {...fellowshipSettings};
        delete newFellowshipSettings.id;
        const query = SQLiteHelperService.insertQuery(SQLiteTables.fellowshipSettings, newFellowshipSettings);
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<IFellowshipSettings>> = db.executeSql(query, []).then((result:ISQLiteResponse<IFellowshipSettings>)=>{
                    fellowshipSettings.id = result.insertId;
                    const response = {...SuccessApiResponse, Data: fellowshipSettings};
                    response.Message.UserMessage = 'SUCCESS: ADDED NEW FELLOWSHIP.';
                    return response;
            }).catch((error)=>{
                const response = {
                    Data: fellowshipSettings,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                return response as IApiResponse<IFellowshipSettings>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },
    getFellowshipSettings: async () =>  {
        const query = `SELECT * FROM ${SQLiteTables.fellowshipSettings} WHERE \`id\`=1`;
        const db = await SQLiteDB();
        if(db) {
            const dbResponse: Promise<IApiResponse<IFellowshipSettings>> = db.executeSql(query, []).then((result:ISQLiteResponse<IFellowshipSettings>)=>{
                if(result.rows.length) {
                    const fellowshipSettings = SQLiteHelperService.convertToJsTypes(result.rows.item(0));
                    console.log('sql fellowshipSettings: ', fellowshipSettings)
                    return  {...SuccessApiResponse, Data: fellowshipSettings};
                } else {
                    return {
                        Data: undefined,
                        Success: false,
                        Message: { UserMessage: 'FAILED: COULD NOT FIND FELLOWSHIP SETTINGS', ServerMessage: 'FAILED TO GET' }
                    }
                }
            }).catch((error)=>{
                const response = {
                    Data: undefined,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                return response as IApiResponse<IFellowshipSettings>;
            });
            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },
    updateFellowshipSettings: async (fellowshipSettings) => {
        const updatedFellowshipSettings = {...fellowshipSettings};
        // FIX: In SQL the id starts at 1 unlike IndexedDB where it starts at 0.
        updatedFellowshipSettings.id = 1;
        const query = SQLiteHelperService.replaceQuery(SQLiteTables.fellowshipSettings, updatedFellowshipSettings);
        const db = await SQLiteDB();

        if(db) {
            const dbResponse: Promise<IApiResponse<IFellowshipSettings>> = db.executeSql(query, []).then((result)=>{
                const response = {...SuccessApiResponse, Data: fellowshipSettings};
                response.Message.UserMessage = 'SUCCESS: UPDATED FELLOWSHIP.';
                return response;
            }).catch((error)=>{
                const response = {
                    Data: fellowshipSettings,
                    Success: false,
                    Message: { UserMessage: error.toString(), ServerMessage: error.toString() }
                }
                return response as IApiResponse<IFellowshipSettings>;
            });

            return dbResponse;
        } else {
            return dbFailedResponse;
        }
    },
}

export default FellowshipSettingsServiceHybrid;